import $ from 'jquery'

export default function hero() {
  const hero = $('.js-top-hero')
  if (!hero.length) return false

  const slickOptions = {
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 1000,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
  }

  hero.fadeIn().slick(slickOptions)
}
